import { LinkButton } from '@cian/ui-kit';

import * as React from 'react';

import { getCianMortgagePromoUrl } from '../../../../utils/getCianMortgagePromoUrl';
import { useApplicationContext } from '../../../../../../utils/applicationContext';

import { PikPhoneNumber } from '../../../../../../containers/PikPhoneNumber';
import { Callback } from '../../../../../../containers/Callback';
import { ECallbackPlace } from '../../../../../../types/callback';

import styles from './ActionButtons.css';

export interface IActionButtonContainerProps {
  onMortgageClick: () => void;
  cianMortgage: boolean;
}

export const ActionButtons: React.FC<IActionButtonContainerProps> = props => {
  const { cianMortgage, onMortgageClick } = props;
  const { config } = useApplicationContext();

  if (cianMortgage) {
    return (
      <LinkButton
        fullWidth
        href={getCianMortgagePromoUrl(config)}
        size="M"
        theme="fill_secondary"
        onClick={onMortgageClick}
      >
        Получить ипотеку онлайн
      </LinkButton>
    );
  }

  return (
    <div className={styles['container']}>
      <PikPhoneNumber />
      <Callback place={ECallbackPlace.MortgageCalculator} />
    </div>
  );
};
